module.exports = __webpack_public_path__ + "static/img/ico-pagseguro.5b79517.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/bancos/ico-pagseguro.png
// module id = Tn66
// module chunks = 0